import React from 'react'

import ATCRegistrationForm from '../Components/ATCRegistrationForm';

function ApplyFranchise() {


    return (
        <>
            <ATCRegistrationForm />
        </>
    )
}

export default ApplyFranchise